import { ArrowLeft, FileImage, Trash2, Undo2, Redo2 } from 'lucide-react';

export const Topbar = ({
  onBackHome,
  onOpenExport,
  onClear,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
}) => {
  return (
    <header
      data-testid="editor-topbar"
      className="relative z-20 flex items-center justify-between gap-4 px-4 sm:px-6 h-16 bg-paper border-b-2 border-ink"
    >
      <div className="flex items-center gap-2 sm:gap-3 min-w-0">
        <button
          data-testid="back-home-btn"
          onClick={onBackHome}
          aria-label="Back to home"
          className="neo-btn bg-paper h-10 w-10 flex-shrink-0"
        >
          <ArrowLeft className="h-4 w-4" />
        </button>
        <div className="hidden sm:flex items-center gap-2">
          <div className="h-8 w-8 border-2 border-ink bg-lilac shadow-brutSm rotate-[-6deg]" />
          <div className="h-8 w-8 border-2 border-ink bg-peach shadow-brutSm -ml-3 rotate-[6deg]" />
          <span className="ml-1 font-outfit font-black text-lg tracking-tight">StckrStckr</span>
        </div>
      </div>

      <div className="hidden lg:flex items-center gap-2 font-outfit text-xs uppercase tracking-widest text-ink/60">
        <span className="h-2 w-2 rounded-full bg-mint border border-ink" />
        Editing · 1024 × 1024
      </div>

      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          data-testid="undo-btn"
          onClick={onUndo}
          disabled={!canUndo}
          aria-label="Undo"
          title="Undo (Ctrl+Z)"
          className="neo-btn bg-paper h-10 w-10 disabled:opacity-40 disabled:cursor-not-allowed disabled:translate-y-0 disabled:shadow-brut"
        >
          <Undo2 className="h-4 w-4" />
        </button>
        <button
          data-testid="redo-btn"
          onClick={onRedo}
          disabled={!canRedo}
          aria-label="Redo"
          title="Redo (Ctrl+Shift+Z)"
          className="neo-btn bg-paper h-10 w-10 disabled:opacity-40 disabled:cursor-not-allowed disabled:translate-y-0 disabled:shadow-brut"
        >
          <Redo2 className="h-4 w-4" />
        </button>

        <div className="h-6 w-px bg-ink/30 mx-1 hidden sm:block" />

        <div className="hidden md:block">
          <button
            data-testid="clear-canvas-btn"
            onClick={onClear}
            aria-label="Clear canvas"
            className="neo-btn bg-paper h-10 px-3 text-sm"
          >
            <Trash2 className="h-4 w-4 mr-1.5" /> Clear
          </button>
        </div>

        <button
          data-testid="export-trigger-btn"
          onClick={onOpenExport}
          aria-label="Export"
          className="neo-btn bg-lilac h-10 px-3 sm:px-4 text-sm"
        >
          <FileImage className="h-4 w-4 sm:mr-2" />
          <span className="hidden sm:inline">Export</span>
        </button>
      </div>
    </header>
  );
};
